  <!-- 土地监管 -->
<template>
    <MainLayout class="c-jiwei-land">
        <BgWrap slot="left" class="c-jiwei-land__left">
            <component v-bind:is="components.Left"></component>
        </BgWrap>
        <BgWrap slot="main" class="c-jiwei-land__main">
            <div class="c-jiwei-land__content">
                <component v-bind:is="components.Middle"></component>
            </div>
        </BgWrap>
        <BgWrap slot="right" class="c-jiwei-land__right">
            <Right></Right>
        </BgWrap>
    </MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout';
import BgWrap from '../layout/components/BgWrap.vue';
import Right from './right.vue';
import createModule from './modules';

const { MainModule } = createModule();
export default {
    components: {
        MainLayout,
        BgWrap,
        // Left,
        Right,
    },
    data() {
        return {
            components: {
                Left: MainModule.outputAsComponent.Left,
                Middle: MainModule.outputAsComponent.Middle,
            },
        };
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$bg-1: #071150;
$bg-2: #03053d;

@include b(jiwei-land, c) {
    color: #fff;
    background: $bg-2;
    padding: 18px 8px 8px 8px;

    @include e(content) {
        padding: 10px;
        height: calc(100% - 20px);
    }

    @include e(left) {
        height: 100%;
        background-color: $bg-1;
    }

    @include e(main) {
        height: 100%;
        margin: 0px 10px;
        background-color: $bg-1;
    }

    @include e(right) {
        height: 100%;
        background-color: $bg-1;

        overflow-x: hidden;
    }
}
</style>
